module.exports = __webpack_public_path__ + "img/qrsample.73d7ca0b.png";